import React, { useEffect } from 'react';
import { filters } from 'components/atoms/tables/smarttables/helpers/filters';
import { get } from 'lodash';
import useCachedState from 'components/atoms/tables/smarttables/helpers/useCachedState';
import ToggleSwitch from 'components/atoms/form/ToggleSwitch';
import styled from 'styled-components';

const FilterBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 38px;
`;

const FilterLabel = styled.span`
    font-size: 12px;
    margin-left: -8px;
`;

const DataToggle = ({
    initialFilter,
    label,
    tableProps,
    cacheKey,
}) => {
    const { setAllFilters, allColumns, state: { filters: filtersApplied } } = tableProps;
    const [isToggleOn, setToggle] = useCachedState(`${cacheKey}-table-data-toggle`, initialFilter);
    const [filterConfig, setFilterConfig] = useCachedState(`${cacheKey}-table-filter-config`, null);

    const toggleFilters = allColumns.reduce((columnFilters, column) => {
        if (column.dataToggle) {
            const filter = filters[column.dataToggle.filter];
            columnFilters.push({
                id: column.id,
                value: {
                    column: column.id,
                    filter: get(filter, 'label', ''),
                    value: get(column.dataToggle, 'value', null),
                    fn: get(filter, 'fn', null),
                    raw: column.dataToggle.filter,
                    hideControl: true
                }
            });
        }

        return columnFilters;
    }, []);
    const toggleIds = toggleFilters.map(toggle => toggle.id);

    useEffect(() => {
        if (isToggleOn && !filterConfig) {
            if (cacheKey) {
                setFilterConfig(toggleFilters);
            }

            setAllFilters(toggleFilters);
        }
    }, []);

    const handleToggle = () => {
        const toggleValue = !isToggleOn;
        setToggle(toggleValue);

        const newFilters = toggleValue
            ? [...filtersApplied.filter(filter => !toggleIds.includes(filter.id)), ...toggleFilters]
            : filtersApplied.filter(filter => !toggleIds.includes(filter.id));

        setAllFilters(newFilters);

        if (cacheKey) {
            setFilterConfig(newFilters);
        }
    };

    return (
        <FilterBar>
            <ToggleSwitch onClick={handleToggle} value={isToggleOn} scale="0.5" />
            <FilterLabel>{ label }</FilterLabel>
        </FilterBar>
    );
};

export default DataToggle;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/DataToggle.js